import { load } from "scrivito"
import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { InstallationReferenceObj } from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"

/**
 * Gets parent building references from installation references.
 * Returns deduplicated array of parent building reference objects.
 */
export async function fetchBuildingReferencesByInstallationReferences(
  installationRefs: InstallationReferenceObj[]
): Promise<BuildingReferenceObj[]> {
  const parents = await Promise.all(
    installationRefs.map(installationRef =>
      load(() => installationRef.parent())
    )
  ).then(parentObjs => {
    return parentObjs.filter(
      (parent): parent is BuildingReferenceObj => parent !== null
    )
  })

  // Deduplicate by ID using reduce
  const uniqueParentsMap = parents.reduce((acc, parent) => {
    const id = parent.id()
    if (!acc.has(id)) {
      acc.set(id, parent)
    }
    return acc
  }, new Map<string, BuildingReferenceObj>())

  return Array.from(uniqueParentsMap.values())
}
